import { Order, OrderOptimizedListResponse } from "../pages/orders/utils/types";
import { useMarketplaceStore } from "../store/useMarketplaceStore";

export const useOrderPurchase = (order: Order | OrderOptimizedListResponse) => {
  const hasAddress = order.orderStatus !== "WAITING_FOR_ADDRESS";
  const marketplaceId = useMarketplaceStore(
    (state) => state.selectedCountry?.id,
  );
  const handlePurchase = () => {
    const amazonBaseUrl = new URL(
      "https://www.amazon.com/gp/aws/cart/add.html",
    );

    amazonBaseUrl.searchParams.set("AssociateTag", "1");
    amazonBaseUrl.searchParams.set(
      "AmazonOrderId",
      String(order.amazonOrderId),
    );
    amazonBaseUrl.searchParams.set("sendType", "1");

    let itemIndex = 1;

    order.orderItems.forEach((item) => {
      const remainingQuantity =
        item.quantityOrdered - (item.quantityBought ?? 0);

      if (remainingQuantity <= 0) return;

      amazonBaseUrl.searchParams.set(
        `ASIN.${itemIndex}`,
        item.asin.toUpperCase(),
      );

      amazonBaseUrl.searchParams.set(
        `Quantity.${itemIndex}`,
        remainingQuantity.toString(),
      );

      itemIndex++;
    });

    if (itemIndex === 1) return;
    amazonBaseUrl.searchParams.set("OrderId", order.id.toString());
    amazonBaseUrl.searchParams.set("MarketplaceId", marketplaceId!.toString());
    window.open(amazonBaseUrl.toString(), "_blank");
  };

  return {
    hasAddress,
    handlePurchase,
  };
};
